export enum TransactionMode {
  pull = 'PULL',
  push = 'PUSH',
}
